import { render, staticRenderFns } from "./deferredExchange.vue?vue&type=template&id=3ba4a700&scoped=true"
import script from "./deferredExchange.vue?vue&type=script&lang=js"
export * from "./deferredExchange.vue?vue&type=script&lang=js"
import style0 from "./deferredExchange.vue?vue&type=style&index=0&id=3ba4a700&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba4a700",
  null
  
)

export default component.exports